import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../../supabaseClient'
import {
  widgetCardStyle,
  labelStyle,
  footerStyle,
} from '../styles/widgetStyles'

function AnnouncementsWidget() {
  const [announcements, setAnnouncements] = useState([])
  const [hover, setHover] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchAnnouncements = async () => {
      const { data, error } = await supabase
        .from('announcements')
        .select('id, title, created_at')
        .order('created_at', { ascending: false })
        .limit(3)

      if (!error) setAnnouncements(data || [])
    }

    fetchAnnouncements()
  }, [])

  return (
    <div
  style={widgetCardStyle(hover, true)}
  onMouseEnter={() => setHover(true)}
  onMouseLeave={() => setHover(false)}
  onClick={() => navigate('/announcements')}
>
  <div style={{ width: '100%', maxWidth: '260px' }}> {/* 👈 NEW WRAPPER */}
    <div style={labelStyle}>
      📢 Latest Announcements <span title="Click to view all updates.">ℹ️</span>
    </div>

    <ul style={{ listStyle: 'none', padding: 0, margin: '0.5rem 0' }}>
      {announcements.length === 0 ? (
        <li style={{ fontSize: '0.9rem', color: '#6b7280' }}>
          No announcements yet
        </li>
      ) : (
        announcements.map((item,idx) => (
          <li
    key={item.id}
    style={{
      fontSize: '0.875rem',
      color: '#1f2937',
      marginBottom: '0.4rem',
      paddingBottom: '0.4rem',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
      textAlign: 'center',
      borderBottom:
        idx !== announcements.length - 1 ? '1px solid #e5e7eb' : 'none',
    }}
  >
    {item.title}{' '}
    <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>
      ({new Date(item.created_at).toLocaleDateString()})
    </span>
  </li>
        ))
      )}
    </ul>

    <div style={footerStyle}>Click anywhere to view all</div>
  </div>
</div>

  )
}

export default AnnouncementsWidget
